import { FC } from "react";

import { AUCTION_USER_NOTIFICATION_TO_DISPLAY_NAME } from "services/auctions/constants";
import { InventoryListingUserNotification } from "services/inventory/types";
import { LISTING_USER_NOTIFICATION_TO_DISPLAY_NAME } from "services/listings/constants";
import { ListingUserNotification } from "services/listings/types";

import Tag, { ColorOptions } from "./Tag";

const LISTING_OR_AUCTION_USER_NOTIFICATION_TO_DISPLAY_NAME = {
  ...LISTING_USER_NOTIFICATION_TO_DISPLAY_NAME,
  ...AUCTION_USER_NOTIFICATION_TO_DISPLAY_NAME,
};

interface UserNotificationTagsProps {
  userNotification: ListingUserNotification | InventoryListingUserNotification;
}

const UserNotificationTags: FC<UserNotificationTagsProps> = ({
  userNotification,
}) => {
  let color: ColorOptions;
  if (
    [
      "filled",
      "filled_for_user",
      "awaiting_acceptance",
      "offer_accepted",
      "upcoming",
      "preview",
      "accepting_opening_bids",
      "live",
    ].includes(userNotification)
  ) {
    color = "green";
  } else if (["pending", "set_price"].includes(userNotification)) {
    color = "yellow";
  } else if (
    ["fail_offer_rejected", "fail_offer_timeout", "outbid"].includes(
      userNotification,
    )
  ) {
    color = "red";
  }

  const notification =
    LISTING_OR_AUCTION_USER_NOTIFICATION_TO_DISPLAY_NAME[userNotification];

  return color && notification ? (
    <Tag color={color} dataTestId="userNotification">
      {notification}
    </Tag>
  ) : null;
};

export default UserNotificationTags;
